import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-save-card-success-mb',
  templateUrl: './save-card-success-mb.component.html',
  styleUrls: ['./save-card-success-mb.component.scss']
})

export class SaveCardSuccessMbComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
